module.exports = __webpack_public_path__ + "img/QR_zl.babc420c.png";